import * as firebase from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import regeneratorRuntime from "regenerator-runtime";
import {
    GF_APIKEY,
    GF_AUTHDOMAIN,
    GF_PROJECTID,
    GF_STORAGEBUCKET,
    GF_MESSAGINGSENDERID,
    GF_APPID,
    GF_MEASUREMENTID,
    GF_PUBLIC_VAPID_KEY
} from './config'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    // firebase.initializeApp({

    apiKey: GF_APIKEY,
    authDomain: GF_AUTHDOMAIN,
    projectId: GF_PROJECTID,
    storageBucket: GF_STORAGEBUCKET,
    messagingSenderId: GF_MESSAGINGSENDERID,
    appId: GF_APPID,
    measurementId: GF_MEASUREMENTID,
};

const initializeFirebase = firebase.initializeApp(firebaseConfig);

const requestForToken = async() => {
    const messaging = getMessaging();
    let public_vapid_key = GF_PUBLIC_VAPID_KEY // Talisis

    const token = await getToken(messaging, { vapidKey: public_vapid_key })
        .then(token => {
            if (token) {
                return token;
            } else {
                console.log('No registration token available. Request permission to generate one.');
                return null;
            }
        })
        .catch(error => {
            if (!("Notification" in window)) {
                alert("This browser does not support desktop notification");
                return null
            }
            alert(`Ocurrio un error: ${error} \nActiva las notificaciónes del navegador y recarga la pagina.`)
            console.log('An error occurred while retrieving token. ', error);
            return null;
        });

    return token;
};

const onMessageListener = (handel) => {
        const messaging = getMessaging();
        onMessage(messaging, (payload) => {
            console.log('Message received. ', payload);
            return payload
        });
    }
    // new Promise(resolve => {
    //     const messaging = getMessaging();
    //     onMessage(messaging, (payload) => {
    //         resolve(payload);
    //     });
    // });

export {
    initializeFirebase,
    requestForToken,
    onMessageListener,
}


// WEBPACK FOOTER //
// ./src/firebase.js